var _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuAssignments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "papers",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "note-2",
    transform: "translate(-0.235 0.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31071",
    "data-name": "Path 31071",
    d: "M15.81,20.18a7.881,7.881,0,0,1-.82-.04,10.839,10.839,0,0,1-1.72-.29l-1.68-.4c-4.61-1.09-6.12-3.53-5.04-8.13l.98-4.19a10.628,10.628,0,0,1,.8-2.36c1.72-3.55,5.01-3.23,7.35-2.68l1.67.39c2.34.55,3.82,1.42,4.65,2.75s.95,3.04.4,5.38l-.98,4.18C20.56,18.45,18.77,20.18,15.81,20.18ZM13.12,3.25A3.457,3.457,0,0,0,9.68,5.42a10.165,10.165,0,0,0-.69,2.05l-.98,4.19c-.89,3.78.14,5.43,3.92,6.33l1.68.4a10.3,10.3,0,0,0,1.51.25c2.72.27,4.07-.92,4.83-4.19l.98-4.18c.45-1.93.39-3.28-.21-4.25S18.94,4.39,17,3.94l-1.67-.39A9.587,9.587,0,0,0,13.12,3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31072",
    "data-name": "Path 31072",
    d: "M8.33,22.25c-2.57,0-4.21-1.54-5.26-4.79L1.79,13.51c-1.42-4.4-.15-6.88,4.23-8.3L7.6,4.7a10.422,10.422,0,0,1,1.26-.33.724.724,0,0,1,.74.28.776.776,0,0,1,.08.79A9.32,9.32,0,0,0,9,7.48l-.98,4.19c-.89,3.78.14,5.43,3.92,6.33l1.68.4a10.3,10.3,0,0,0,1.51.25.769.769,0,0,1,.67.56.752.752,0,0,1-.3.81,9.891,9.891,0,0,1-2.54,1.17l-1.58.52A10.288,10.288,0,0,1,8.33,22.25ZM7.78,6.22l-1.29.42C2.92,7.79,2.07,9.47,3.22,13.05L4.5,17c1.16,3.57,2.84,4.43,6.41,3.28l1.58-.52c.06-.02.11-.04.17-.06l-1.06-.25c-4.61-1.09-6.12-3.53-5.04-8.13l.98-4.19C7.61,6.81,7.69,6.5,7.78,6.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31073",
    "data-name": "Path 31073",
    d: "M17.49,10.51a1.366,1.366,0,0,1-.19-.02L12.45,9.26a.748.748,0,0,1,.37-1.45l4.85,1.23a.746.746,0,0,1-.18,1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31074",
    "data-name": "Path 31074",
    d: "M14.56,13.89a1.366,1.366,0,0,1-.19-.02l-2.91-.74a.748.748,0,0,1,.37-1.45l2.91.74a.749.749,0,0,1,.54.91A.728.728,0,0,1,14.56,13.89Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8668",
    "data-name": "Rectangle 8668",
    width: 24,
    height: 24,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuAssignments);
export default __webpack_public_path__ + "static/media/menu-assignments.982a541c0f1354a8a94d2217c33ef214.svg";
export { ForwardRef as ReactComponent };